import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Brak produktów.',
  fields: {
    number: '#',
    image: 'Obraz',
    name: 'Nazwa',
    external_id: '{{integration}} ref',
    price: 'Cena',
    prices: 'Ceny',
    description: 'Opis',
    tags: 'Tagi',
    status: 'Status',
    product_type: 'Typ',
    statuses: {
      good: 'Dobry',
      bad: 'Zły',
      medium: 'Średni',
    },
    product_types: {
      packaged: 'Pakowany',
      prepared: 'Przygotowany',
    },
  },
  labels: {
    visible: 'Widoczny w menu',
    hidden: 'Wszystkie ukryte',
  },
  order_method_prices: {
    base: 'Podstawa',
    [ORDER_METHODS.pickup]: 'Odbiór',
    [ORDER_METHODS.delivery]: 'Dostawa',
    [ORDER_METHODS.on_site]: 'Zamawianie przy stoliku',
  },
  buttons: {
    delete_products_one: 'Usuń produkt',
    delete_products_few: 'Usuń produkty',
    delete_products_many: 'Usuń produkty',
    delete_products_other: 'Usuń produkty',
    add_product: '+ Dodaj produkt',
    show_products: 'Pokaż produkty',
    hide_products: 'Ukryj produkty',
    add: 'Dodaj',
    edit: 'Edytuj',
    duplicate: 'Duplikuj',
    history: 'Historia',
    delete: 'Usuń',
    delete_all: 'Usuń wszystkie',
  },
  toasts: {
    failed_to_duplicate_category: 'Nie udało się zduplikować kategorii',
    category_duplicated_successfully: 'Kategoria zduplikowana pomyślnie',
    failed_to_duplicate_product: 'Nie udało się zduplikować produktu',
    product_duplicated_successfully: 'Produkt zduplikowany pomyślnie',
    failed_to_delete_variant: 'Nie udało się usunąć wariantu',
    variant_got_deleted: 'Wariant został usunięty',
    something_went_wrong: 'Coś poszło nie tak',
  },
};
